export default __webpack_public_path__ + "static/media/Tick_2.5fe79c26.svg";